import React, { useContext, useEffect, useMemo } from 'react'
import { Page, Text, View, Document, PDFViewer, Image, PDFDownloadLink, BlobProvider } from '@react-pdf/renderer';
import { v4 as uuid } from 'uuid';
import UserContext from '../../../context/Globales/UserContext';
import moment from 'moment';
import { Divider } from '@material-ui/core';
import { UrlqrPdf } from '../../../helpers/UrlqrPdf';

const IcpdfResumenSociedadSocModal = () => {




    const { DatoListaSAModal, datoICMODAL } = useContext(UserContext);

    moment.locale('spanish');
    const Fecha = moment().format('LLLL'); // FORMATO: Domingo 15 Julio 2012 11:01
    const dataUrlQr = UrlqrPdf();

    const TblSociedadesResumenpdf = (
        <>
            {DatoListaSAModal.Resumen != null ?
                <View style={{ width: '100%' }}>

                    <View style={{ flexDirection: 'row', fontSize: 8, backgroundColor: '#e6e6e6', color: 'black' }}>

                        <Text style={{ width: '20%', height: '25px', padding: '1,10', textAlign: 'center' }}>N°. de Publicaciones</Text>
                        <Text style={{ width: '20%', height: '25px', padding: '1,10', textAlign: 'center' }}>N°. Sociedades</Text>
                        <Text style={{ width: '20%', height: '25px', padding: '1,10', textAlign: 'center' }}>N°. de Socios</Text>


                    </View>
                    <View style={{ flexDirection: 'row', fontSize: 8 }} key={uuid()}>

                        <Text style={{ width: '20%', borderBottom: '1 solid #e6e6e6 ', height: '25px', textAlign: 'center' }}>{DatoListaSAModal.Resumen?.NumeroPublicaciones}</Text>
                        <Text style={{ width: '20%', borderBottom: '1 solid #e6e6e6 ', height: '25px', textAlign: 'center' }}>{DatoListaSAModal.Resumen?.ComoSociedades}</Text>
                        <Text style={{ width: '20%', borderBottom: '1 solid #e6e6e6 ', height: '25px', textAlign: 'center' }}>{DatoListaSAModal.Resumen?.ComoSocio}</Text>
                    </View>


                </View>

                : <Text style={{ fontSize: 9 }} >SIN INFORMACIÓN  </Text>}
        </>
    );

    const TblDetalleSocidadespdf = (
        <>
            {DatoListaSAModal.DetalleSociedades != null ?
                <View style={{ width: '100%' }}>




                    <View style={{ flexDirection: 'row', fontSize: 8, backgroundColor: '#e6e6e6', color: 'black' }}>

                        <Text style={{ width: '5%', height: '25px', padding: '1,10', textAlign: 'center' }}>#</Text>
                        <Text style={{ width: '40%', height: '25px', textAlign: 'left' }}>Nombre</Text>
                        <Text style={{ width: '40%', height: '25px', textAlign: 'left' }}>Constituidad como</Text>
                        <Text style={{ width: '15%', height: '25px', textAlign: 'center' }}>Fecha Escritura</Text>



                    </View>


                    {DatoListaSAModal.DetalleSociedades?.map((resSociedpdf, idSociedpdf) => (

                        <View style={{ flexDirection: 'row', fontSize: 8 }} key={idSociedpdf}>
                            <Text style={{ width: '5%', borderBottom: '1 solid #e6e6e6 ', height: '25px', padding: '1,10', textAlign: 'center' }}>{idSociedpdf + 1}</Text>
                            <Text style={{ width: '40%', borderBottom: '1 solid #e6e6e6 ', height: '25px', textAlign: 'left' }}>{resSociedpdf.Detalles[0].NombreRazonSocial}</Text>
                            <Text style={{ width: '40%', borderBottom: '1 solid #e6e6e6 ', height: '25px', textAlign: 'left' }}>{resSociedpdf.Detalles[0].ConstituidaComo}</Text>
                            <Text style={{ width: '15%', borderBottom: '1 solid #e6e6e6 ', height: '25px', textAlign: 'left' }}>{resSociedpdf.Detalles[0].FechaEscritura}</Text>
                        </View>
                    ))}

                </View>

                : <Text style={{ fontSize: 9 }} >SIN INFORMACIÓN </Text>}
        </>
    );

    const TblDetalleSociopdf = (
        <>
            {DatoListaSAModal.DetalleSocios != null ?
                <View style={{ width: '100%' }}>




                    <View style={{ flexDirection: 'row', fontSize: 8, backgroundColor: '#e6e6e6', color: 'black' }}>

                        <Text style={{ width: '5%', height: '25px', padding: '1,10', textAlign: 'center' }}>#</Text>
                        <Text style={{ width: '40%', height: '25px', textAlign: 'left' }}>Nombre</Text>
                        <Text style={{ width: '40%', height: '25px', textAlign: 'left' }}>Constituidad como</Text>
                        <Text style={{ width: '15%', height: '25px', textAlign: 'center' }}>Fecha Escritura</Text>



                    </View>


                    {DatoListaSAModal.DetalleSocios?.map((resSociopdf, idSociospdf) => (

                        <View style={{ flexDirection: 'row', fontSize: 8 }} key={idSociospdf}>
                            <Text style={{ width: '5%', borderBottom: '1 solid #e6e6e6 ', height: '25px', padding: '1,10', textAlign: 'center' }}>{idSociospdf + 1}</Text>
                            <Text style={{ width: '40%', borderBottom: '1 solid #e6e6e6 ', height: '25px', textAlign: 'left' }}>{resSociopdf.Detalles[0].NombreRazonSocial}</Text>
                            <Text style={{ width: '40%', borderBottom: '1 solid #e6e6e6 ', height: '25px', textAlign: 'left' }}>{resSociopdf.Detalles[0].ConstituidaComo}</Text>
                            <Text style={{ width: '15%', borderBottom: '1 solid #e6e6e6 ', height: '25px', textAlign: 'left' }}>{resSociopdf.Detalles[0].FechaEscritura}</Text>
                        </View>
                    ))}

                </View>

                : <Text style={{ fontSize: 9 }} >SIN INFORMACIÓN </Text>}
        </>
    );

    const ReporteResumenSociedades = () => (

        <Document >

            <Page size="letter" style={{ paddingTop: 15, paddingBottom: 40, paddingHorizontal: 20 }} >
                <View>


                    <Image src={process.env.PUBLIC_URL + '/static/imagen/logonewp.png'} style={{ width: '100%', padding: '2' }} fixed />

                    <Text style={{ fontSize: 9, textAlign: 'right' }} fixed>FECHA IMPRESIÓN: {Fecha}</Text>
                    <Text style={{ fontSize: 10, textAlign: 'right' }} render={({ pageNumber, totalPages }) => (`PÁGINA ${pageNumber} / ${totalPages}`)} fixed />

                    <View fixed>
                        <Text style={{ width: '100%', textAlign: 'center', backgroundColor: '#bbdefb', color: 'black', marginTop: 8, padding: '5,15' }}  >{datoICMODAL.Identificacion?.IsEmpresa ? datoICMODAL.DetalleIdentificacionEmpresa?.Nombre : datoICMODAL.Identificacion?.Nombre} RUT {datoICMODAL.Identificacion?.Rut}</Text>
                    </View>

                    <View style={{ width: '100%' }}>
                        <Text style={{ width: '100%', textAlign: 'left', backgroundColor: '#e6e6e6', color: 'black', marginTop: 8, padding: '5,15', fontSize: '11' }}>RESUMEN SOCIEDADES Y SOCIOS</Text>
                        {TblSociedadesResumenpdf}
                    </View>

                    <View style={{ width: '100%' }}>
                        <Text style={{ width: '100%', textAlign: 'left', backgroundColor: '#e6e6e6', color: 'black', marginTop: 8, padding: '5,15', fontSize: '11' }}>DETALLE SOCIEDADES</Text>
                        {TblDetalleSocidadespdf}
                    </View>

                    <View style={{ width: '100%' }}>
                        <Text style={{ width: '100%', textAlign: 'left', backgroundColor: '#e6e6e6', color: 'black', marginTop: 8, padding: '5,15', fontSize: '11' }}>DETALLE SOCIOS</Text>
                        {TblDetalleSociopdf}
                    </View>

                   
                    <View style={{ width: '50%', alignContent: 'left' }}>
                        {/* <Image src={dataUrlQr.urlQrPDF} style={{ width: '20%', padding: '5' }} />
                       <Image src={process.env.PUBLIC_URL + '/static/imagen/IconoEmpresa/qrPortacheque.png'} style={{ width: '30%', padding: '5' }} /> */}
                        <Text style={{ width: '100%', textAlign: 'center', backgroundColor: '#e6e6e6', color: 'black', marginTop: 8, padding: '5,15', fontSize: '11' }}>Nro. FOLIO: {datoICMODAL.ID} - {uuid(datoICMODAL.ID)}</Text>
                    </View>
                    



                </View>


            </Page>

        </Document>

    );





    return useMemo(
        () => (
            <div>
                <h1>Informe Resumen Sociedades y Socios</h1>
                <Divider />

                <PDFDownloadLink document={<ReporteResumenSociedades />} fileName={`${uuid()}.pdf`}>

                    {({ blob, url, loading, error }) => (loading ? <h2 style={{ textAlign: 'center', fontSize: '18px' }}>Ten paciencia, estamos generando el PDF... </h2> : <h2 style={{ textAlign: 'center', fontSize: '22px' }}>DESCARGAR</h2>)}

                </PDFDownloadLink>



            </div>
        ), []

    );
}

export default IcpdfResumenSociedadSocModal;
